import { VehiclePromptKind } from '../physics'

export interface VehiclePromptButtonProps {
  /** 乗降プロンプト（'enter'=近くの車に乗れる / 'exit'=乗車中）。 */
  vehiclePrompt: VehiclePromptKind
  /** クリック/タップ時の乗降アクション（E キーと同じ動作）。 */
  onTrigger: () => void
}

/**
 * 乗降ボタン（実機の ProximityPrompt 相当）。車の近く（'enter'）か
 * 乗車中（'exit'）に表示し、クリック/タップは E キーと同じ動作。
 */
export function VehiclePromptButton({
  vehiclePrompt,
  onTrigger,
}: VehiclePromptButtonProps) {
  if (vehiclePrompt === null) {
    return null
  }
  return (
    <button
      type="button"
      aria-label={
        vehiclePrompt === 'enter' ? 'くるまにのる' : 'くるまからおりる'
      }
      onClick={onTrigger}
      style={{
        position: 'absolute',
        bottom: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '8px 18px',
        borderRadius: 999,
        border: 'none',
        background: 'rgba(20, 24, 32, 0.82)',
        color: '#fff',
        fontSize: 16,
        fontWeight: 700,
        cursor: 'pointer',
        zIndex: 10,
        pointerEvents: 'auto',
      }}
    >
      <span>{vehiclePrompt === 'enter' ? 'のる' : 'おりる'}</span>
      <span
        style={{
          padding: '1px 8px',
          borderRadius: 6,
          background: 'rgba(255, 255, 255, 0.92)',
          color: '#111',
          fontSize: 13,
          fontWeight: 700,
          fontFamily: 'monospace',
        }}
      >
        E
      </span>
    </button>
  )
}
